'use client'

import { Button } from '@/components/ui/button'
import { useActiveCustomer } from '@/lib/hooks'
import { User } from 'lucide-react'
import Link from 'next/link'
import { ComponentProps } from 'react'

export function SignInButton({ variant, ...props }: ComponentProps<typeof Button>) {
  const { data: activeCustomer } = useActiveCustomer()

  if (activeCustomer) {
    return (
      <Button
        variant={variant ?? 'secondary'}
        asChild
        {...props}
      >
        <Link
          href="/account"
          data-testid="navbar-user-account-button"
        >
          <User /> {activeCustomer.firstName} {activeCustomer.lastName.substring(0, 1) + '.'}
        </Link>
      </Button>
    )
  }

  return (
    <Button
      variant={variant ?? 'secondary'}
      asChild
      {...props}
    >
      <Link
        href="/sign-in"
        data-testid="navbar-sign-in-button"
      >
        <User /> Sign In
      </Link>
    </Button>
  )
}
